import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-animation.css.lit';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';

import animations from './animations';
/**
 * The PcAnimation component
 * @element pc-animation
 */
@customElement('pc-animation')
export class PcAnimation extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /** The name of the animation to draw. */
  @property()
  name?: string;

  /**
   * Optional delay for animation
   */
  @property({ type: Number })
  delay = 0;

  updated() {
    const pathRef = this.shadowRoot?.querySelector(
      'path'
    ) as SVGGeometryElement;
    this.style.setProperty('--line-length', `${pathRef.getTotalLength()}`);
    this.style.setProperty('--animation-delay', `${this.delay}s`);
  }
  render(): TemplateResult {
    const animationSVG = animations[this.name as keyof typeof animations];
    return html`${unsafeSVG(animationSVG)}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-animation': PcAnimation;
  }
}
